export default __webpack_public_path__ + "static/media/register-background.5daa60c3.jpg";